export const RGBA = {
	blue: [0, 0, 255, 255],
	red: [255, 0, 0, 255],
	purple: [128, 0, 128, 255],
	yellow: [255, 255, 0, 255],
	gray: [128, 128, 128, 255],
	cyan: [0, 255, 255, 255],
	green: [0, 128, 0, 255],
	orange: [255, 165, 0, 255],
	white: [255, 255, 255, 255],
	black: [0, 0, 0, 255],
}
